import { ReactNode, useState } from "react";

const SVGandTextContainer = ({
  tooltipID,
  SVGIcon,
  toolbarOpen,
  openText,
}: {
  tooltipID: string;
  SVGIcon: any;
  toolbarOpen: boolean;
  openText: string | ReactNode;
}) => {
  const [hoveOverIcon, setHoveOverIcon] = useState(false);

  return (
    <div
      data-tooltip-id={tooltipID}
      className="flex w-fit rounded-lg hover:bg-cubeBase-700 dark:hover:bg-cubeBaseDark-700"
    >
      <div
        className={`flex h-[35px] w-[35px] items-center justify-center text-cubeBase-600 dark:text-cubeBaseDark-600 ${tooltipID == "SidebarToggle" ? "cursor-pointer hover:text-orange-600 dark:hover:text-orange-400" : ""}`}
        onMouseEnter={() => setHoveOverIcon(!hoveOverIcon)}
        onMouseLeave={() => setHoveOverIcon(!hoveOverIcon)}
        id={tooltipID + "IconContainerCollapsed"}
      >
        {SVGIcon}
      </div>
      {openText != "" && (
        <div
          className={`${toolbarOpen ? "flex h-[35px] w-full items-center justify-start  pl-2" : "hidden"} text-gray-500 dark:text-gray-200`}
          id={openText?.toString().replace(/\s+/g, "")}
        >
          {openText}
        </div>
      )}
    </div>
  );
};

export default SVGandTextContainer;
